var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._l((5),function(i){return _c('v-list-item',{key:i,attrs:{"mx-1":""}},[_c('v-list-item-avatar',[_c('v-skeleton-loader',{attrs:{"type":"avatar"}})],1),_c('v-list-item-content',{staticStyle:{"margin-left":"-15px"}},[_c('v-skeleton-loader',{attrs:{"type":"list-item-two-line"}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }